export const closePopUp = () => {
	
	const popUp = document.querySelector('.pop-up');
	const popUpIcon =  document.querySelector('.pop-up__icon');

	if (!popUp || !popUpIcon) {
        // One or both of the elements don't exist, so return or handle accordingly
        return;
    }

	function displayPopup() {
			popUp.style.display = 'block';
	}
	
	function closePopup() {
		popUp.style.display = 'none';
	}

	window.addEventListener("DOMContentLoaded", displayPopup);
	popUpIcon.addEventListener("click", closePopup);

}